/* eslint-disable */
"use client"
import { useState, useEffect, useRef } from "react"

export const useScreenSize = () => {
  const [width, setWidth] = useState(0)
  const rafRef = useRef<number | null>(null)

  useEffect(() => {
    if (typeof window === "undefined") return

    setWidth(window.innerWidth)

    const updateWindowDimensions = () => {
      if (rafRef.current !== null) return
      rafRef.current = requestAnimationFrame(() => {
        setWidth(window.innerWidth)
        rafRef.current = null
      })
    }

    window.addEventListener("resize", updateWindowDimensions, { passive: true })

    return () => {
      window.removeEventListener("resize", updateWindowDimensions)
      if (rafRef.current !== null) cancelAnimationFrame(rafRef.current)
    }
  }, [])

  return { width }
}
